import { api } from '../client';
import { unwrap } from '../unwrap';

export interface QuotaItem {
  metric: string;
  unit: string;
  limit: number | null;
  used: number;
  remaining: number | null;
  unlimited: boolean;
}

export interface PlanInfo {
  code: string;
  name: string;
  tier: string;
  interval_unit: string;
  interval_count: number;
  trial_days: number | null;
  features: Record<string, unknown>;
  platform_product_ids: Record<string, unknown>;
}

export interface SubscriptionState {
  id: string;
  plan_code: string | null;
  platform: string;
  external_product_id: string | null;
  external_transaction_id: string;
  original_transaction_id: string | null;
  status: string;
  auto_renew: boolean | null;
  started_at: string | null;
  expires_at: string | null;
  trial_ends_at: string | null;
  canceled_at: string | null;
  extra: Record<string, unknown>;
}

export interface EntitlementSnapshot {
  period_key: string;
  plan: PlanInfo;
  active_subscriptions: SubscriptionState[];
  quotas: QuotaItem[];
  usage_summary: Record<string, number>;
}

export const entitlementsApi = {
  async me(): Promise<EntitlementSnapshot> {
    const raw = await api.get<unknown>('/api/v1/entitlements/me');
    return unwrap<EntitlementSnapshot>(raw);
  },
};
